import { book as actions, map as mapActions } from '../../../data/booking/constants/action_types';
import * as api from '../../../data/booking/api/api';
import * as serviceTypes from '../../../data/booking/constants/service_types';
import { fetchUserSession as apiFetchUserSession, fetchRoutes, fetchLines, searchHikes } from '../../../data/shared/api/api';
import { arrayOfRoutes, arrayOfLines } from '../../../data/booking/api/schema';
import { reservation } from '../../../data/followup/api/schema';
import { v4 as uuid } from 'uuid';
import { normalize } from 'normalizr';
import omit from 'lodash/omit';
import has from 'lodash/has'
import isArray from 'lodash/isArray';
import {denormalize, denormalizeToUpdate} from '../../../data/booking/denormalizers/submit';
import { getIsSaveDraftSuccessful, getDefaultDataFromState } from "../../../data/booking/selectors/booking";
import { fetchData, fetchDataOptimalle } from "../../../data/followup/api/api";
import { loadHike } from "../../../data/booking/actions/map";
import { arrayOfHikes, arrayOfThemes } from "../api/schema";
import { STAGE_ADD_SERVICE, STAGE_ADD_STEP, STAGE_CHOOSE_SERVICE, STAGE_SUMMARY } from "../constants/stages";
import { BAG_TRANSPORT } from "../constants/service_types";
import { getCustomerHistory } from "../../../data/account/api/api";
import {addServiceFromSession, selectArrival, selectDeparture} from "./map";

const fetchUserSession = () => dispatch => {
    dispatch({
        type: actions.REQUEST_USER_SESSION
    });

    return apiFetchUserSession()
        .then(response => response.json())
        .then(json => dispatch({
            type: actions.RECEIVE_USER_SESSION,
            data: json.data
        }));
};

const fetchRouteList = (filters) => dispatch => {
    dispatch({
        type: actions.REQUEST_ROUTES
    });

    return fetchRoutes(filters)
        .then(response => response.json())
        .then(json => normalize(json, arrayOfRoutes))
        .then(normalized => dispatch({
            type: actions.RECEIVE_ROUTES,
            data: normalized
        }));
};


const fetchHikeList = (query = null) => dispatch => {
    dispatch({
        type: actions.REQUEST_HIKES
    });

    return searchHikes(query,)
        .then(response => response.json())
        .then(json => normalize(json.hikes, arrayOfHikes))
        .then(normalized => dispatch({
            type: actions.RECEIVE_HIKES,
            data: normalized
        }));
};

const fetchThemes = (locale) => dispatch => {
    dispatch({
        type: actions.REQUEST_THEMES
    });

    return api.getThemes(locale)
        .then(response => response.json())
        .then(json => normalize(json, arrayOfThemes))
        .then(normalized => dispatch({
            type: actions.RECEIVE_THEMES,
            data: normalized
        }));
};

const fetchLineList = (routeId) => dispatch => {
    dispatch({
        type: actions.REQUEST_SHUTTLE_LINES
    });

    return fetchLines(routeId)
        .then(response => response.json())
        .then(json => normalize(json, arrayOfRoutes))
        .then(normalized => dispatch({
            type: actions.RECEIVE_SHUTTLE_LINES,
            data: normalized
        }));
};

const fetchDraft = (reference) => (dispatch, getState) => {
    dispatch({
        type: actions.REQUEST_DRAFT_QUOTE
    });

    return fetchData(reference)
        .then(response => {
            if (response.ok) {
                return response
            }
            throw new Error('not found')
        })
        .then(response => response.json())
        .then(json => normalize(json.data, reservation))
        .then(normalized => {
            const draft = normalized.entities.reservations[normalized.result]
            if(draft.type == 'reservation' && !draft.isEditable){
                return dispatch({
                    type: actions.RECEIVE_DRAFT_QUOTE_ERROR,
                    reference
                })
            }
            Object.keys(normalized.entities.hikes).forEach(hikeId => {
                const hike = normalized.entities.hikes[hikeId]
                dispatch(loadHike(hike));
            })
            dispatch({
                type: actions.RECEIVE_DRAFT_QUOTE,
                reference,
                clientData : draft.clientData,
                endUser: draft.endUser,
                data: normalized
            })
            return resetSession()
        })
        .catch(error => {
            return dispatch({
                type: actions.RECEIVE_DRAFT_QUOTE_ERROR,
                reference
            })
        });
};

const fetchOptimalle = (reference, route) => (dispatch, getState) => {
    dispatch({
        type: actions.REQUEST_OPTIMALLE
    });

    return fetchDataOptimalle(reference, route)
        .then(response => {
            if (response.ok) {
                return response
            }
            throw new Error('not found')
        })
        .then(response => response.json())
        .then(json => normalize(json.data, reservation))
        .then(normalized => {
            const hike = normalized.entities.hikes[Object.keys(normalized.entities.hikes)[0]]
            dispatch(loadHike(hike));

            dispatch({
                type: actions.RECEIVE_OPTIMALLE,
                data: normalized
            })

            saveStateToSession(getState())
        })
        .catch(error => {
            dispatch({
                type: actions.RECEIVE_OPTIMALLE_ERROR,
                reference
            })
        });
};

const submitEndUser = (data) => ({
    type: actions.SUBMIT_END_USER,
    data
});

const submitClientData = (data) => ({
    type: actions.SUBMIT_CLIENT_DATA,
    data
});

const editEndUser = (data) => ({
    type: actions.EDIT_END_USER
});

const showAddService = () => ({
    type: actions.SHOW_ADD_SERVICE
});

const closeAddService = () => ({
    type: actions.CLOSE_ADD_SERVICE
});

const addService = serviceType => dispatch => {
    switch (serviceType) {
        case serviceTypes.BAG_TRANSPORT:
            // Pour un transport de bagages, on a besoin de connaitre la route
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
        case serviceTypes.BIKE_TRANSPORT:
            // Pour un transport de vélo, on a besoin de connaitre la route
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
        case serviceTypes.PEOPLE_TRANSPORT:
            // Pour un transport de personnes, on a besoin de connaitre la route
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
        case serviceTypes.REGULAR_SHUTTLE:
            // Pour une navette régulière, on a besoin de connaitre la ligne
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
        case serviceTypes.CAR_TRANSPORT:
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
        case serviceTypes.CAR_PARKING:
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
        case serviceTypes.CUSTOM:
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
        case serviceTypes.CANCELLATION:
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
        case serviceTypes.ROADBOOK_MHIKES:
            return dispatch({
                type: actions.REQUEST_SERVICE_DATA,
                serviceType
            });
    }

    return dispatch(submitService(serviceType));
};

const addServiceData = (data = null, thenAddService = false) => (dispatch, getState) => {
    if (data == null) {
        data = getDefaultDataFromState(getState().booking)
    }

    const { serviceType } = getState().booking.booking.serviceAdd;
    let stage = thenAddService ? (serviceType == BAG_TRANSPORT ? STAGE_ADD_STEP : STAGE_ADD_SERVICE) : STAGE_CHOOSE_SERVICE;

    return Promise.resolve(dispatch({
        type: actions.ADD_SERVICE_DATA,
        data,
        stage
    })).then(() => {
        if (thenAddService) {
            return dispatch(submitService(serviceType));
        }
    }).catch(error => console.log(error));
};

const submitService = (serviceType) => (dispatch, getState) => {
    const { data } = getState().booking.booking.serviceAdd;
    const serviceId = 'group-' + uuid();

    Promise.resolve(dispatch({
        type: actions.SUBMIT_SERVICE,
        data: {
            id: serviceId,
            type: serviceType,
            data: omit(data, 'items')
        }
    })).then(() => {
        if (has(data, 'items') && isArray(data.items)) {
            data.items.forEach(item => {
                dispatch(submitServiceItem(serviceId, item));
            });
        }
    });
};

const addServiceItem = (serviceId) => {
    return {
        type: actions.ADD_SERVICE_ITEM,
        serviceId
    };
};

const submitServiceItem = (serviceId, data, nextStage = null) => (dispatch, getState) => {
    const itemId = 'service-' + uuid();

    const service = getState().booking.booking.entities.services[serviceId]
    let stage = nextStage ? nextStage : (service.type == BAG_TRANSPORT ? STAGE_ADD_STEP : STAGE_ADD_SERVICE);

    return Promise.resolve(dispatch({
        type: actions.SUBMIT_SERVICE_ITEM,
        serviceId,
        itemId,
        stage,
        data: {
            ...data,
            id: itemId
        }
    })).then(() => {
        dispatch(sortServiceItems(serviceId));
    });
};

const removeService = (serviceId) => dispatch => {
    return Promise.resolve(dispatch({
        type: actions.REMOVE_SERVICE,
        serviceId
    }));
};

const cancelAddService = () => ({
    type: actions.CANCEL_ADD_SERVICE
});

const toggleEditServiceItem = (serviceId, itemId) => (dispatch, getState) => {

    const service = getState().booking.booking.entities.services[serviceId]
    let stepIndex = service.items.indexOf(itemId)
    return dispatch({
        type: actions.TOGGLE_EDIT_SERVICE_ITEM,
        serviceId,
        itemId,
        stepIndex
    })
};

const updateServiceItem = (itemId, data) => (dispatch, getState) => {
    const serviceId = getState().booking.booking.editingService;

    return Promise.resolve(dispatch({
        type: actions.UPDATE_SERVICE_ITEM,
        serviceId,
        itemId,
        data
    }))
        .then(() => dispatch(sortServiceItems(serviceId)));
    // .then(() => dispatch(success("Modifications de l'élément enregistrées.")));
};

const removeServiceItem = (serviceId, itemId, doCalculatePrice = true) => (dispatch, getState) => {
    return Promise.resolve(dispatch({
        type: actions.REMOVE_SERVICE_ITEM,
        itemId,
        serviceId
    })).then(() => {
        const service = getState().booking.booking.entities.services[serviceId];
        if (service.items.length <= 0) {
            return dispatch(removeService(serviceId));
        }
    });
    //     .then(() => {
    //     if (doCalculatePrice) {
    //         return dispatch(calculatePrice());
    //     }
    // });
};

const sortServiceItems = (serviceId) => ({
    type: actions.SORT_SERVICE_ITEMS,
    serviceId
});

const cancel = () => ({
    type: actions.CANCEL
});

const changeComment = (comment) => ({
    type: actions.CHANGE_COMMENT,
    comment
});

const showSubmit = () => ({
    type: actions.SHOW_SUBMIT
});

const submit = () => (dispatch, getState) => {
    dispatch({
        type: actions.SUBMIT
    });

    const {booking} = getState().booking;
    let data = booking.isUpdating ? denormalizeToUpdate(booking) : denormalize(booking)

    return api.postQuotation(data)
        .then(response => {
            if (response.ok) {
                resetSession();
                return dispatch({
                    type: actions.SUBMIT_SUCCESS,
                    data: response.body
                });
            }

            return dispatch({
                type: actions.SUBMIT_FAILURE,
                error: null // TODO
            });
        })
        .catch(error => {
            console.log(error);
            return dispatch({
                type: actions.SUBMIT_FAILURE,
                error
            });
        });
};

const saveDraft = () => (dispatch, getState) => {
    dispatch({
        type: actions.SUBMIT_DRAFT
    });

    return api.postDraftQuote(denormalize(getState().booking.booking))
        .then(response => {
            if (response.ok) {
                resetSession();
                return dispatch({
                    type: actions.SUBMIT_DRAFT_SUCCESS,
                    data: response.body ?? JSON.parse(response.text)
                });
            }

            return dispatch({
                type: actions.SUBMIT_DRAFT_FAILURE,
                error: null // TODO
            });
        })
        .catch(error => {
            console.log(error);
            return dispatch({
                type: actions.SUBMIT_FAILURE,
                error
            });
        });
};

const termsReaded = () => ({
    type: actions.TERMS_READED
});

const termsAccepted = () => ({
    type: actions.TERMS_ACCEPTED
});

const termsRejected = () => ({
    type: actions.TERMS_REJECTED
});

const getSessionHandler = () => {
    try {
        sessionStorage.length;
        return sessionStorage;
    } catch(e) {
        return {};
    }
}

const loadSession = () => (dispatch, getState) => {
    window.onerror = function (error) {
        if (getSessionHandler().booking) {
            resetSession()
            //location.reload()
        }
    };
    if (getSessionHandler().booking != null) {
        try {
            return Promise.resolve(dispatch({
                type: actions.LOAD_SESSION,
                state: JSON.parse(getSessionHandler().booking)
            }))
        } catch {
            resetSession()
        }
    }
    return Promise.resolve({ state: null })
}

const getSessionContent = () => {
    if (getSessionHandler().booking) {
        return JSON.parse(getSessionHandler().booking)
    }
    return null;
}

const saveStateToSession = (state) => {
    // on n'enregistre pas le brouillon en mémoire si on vient de l'envoyer au serveur.
    if (!getIsSaveDraftSuccessful(state.booking)) {
        console.log('saving session')
        try {
            getSessionHandler().booking = JSON.stringify(state.booking)
        } catch {
            console.log("warning : error when saving")
        }
    } else {
        resetSession()
    }
}

const resetSession = () => {
    console.log('reset session')
    getSessionHandler().booking = null;
}

const setStage = (stage) => ({
    type: actions.SET_STAGE,
    stage
});



const requestDraftCount = () => ({
    type: actions.REQUEST_DRAFT_COUNT
});

const receiveDraftCount = (draftCount) => ({
    type: actions.RECEIVE_DRAFT_COUNT,
    draftCount
});

const fetchDraftCount = () => (dispatch) => {
    dispatch(requestDraftCount())

    return getCustomerHistory({ type: 'draft' })
        .then(response => response.json())
        .then(json => {
            return dispatch(receiveDraftCount(json.length))
        })
}


const fetchExistingBooking = () => (dispatch, getState) => {
    dispatch({
        type: actions.REQUEST_EXISTING_BOOKING
    });

    const {entities, data } = getState().booking.booking

    let route = null
    let startAt = null
    let endAt = null
    data.services.forEach(serviceId => {
        const service = entities.services[serviceId]
        route = service.route.id
        service.items.forEach(itemId => {
            const item = entities.items[itemId]
            if(!startAt || startAt > item.startDate){
                startAt = item.startDate
            }
            if(!endAt || endAt < item.endDate){
                endAt = item.endDate
            }
        })
    })

    let filters = {
        route,
        startAt,
        endAt
    }

    return api.fetchMatchingBooking(filters)
        .then(response => {
            if (response.ok) {
                return response
            }
            throw new Error('not found')
        })
        .then(response => response.json())
        .then(match => {
            return dispatch({
                type: actions.RECEIVE_EXISTING_BOOKING,
                match
            })
        })
        .catch(error => {
            return dispatch({
                type: actions.RECEIVE_EXISTING_BOOKING,
                match: null
            })
        });
};

const addSessionToDraft = (session) => (dispatch, getState) => {
    Object.keys(session.booking.entities.services).map(serviceId=> {
        const service = session.booking.entities.services[serviceId]

        dispatch({
            type: actions.REQUEST_SERVICE_DATA,
            serviceType: service.type
        })
        return Promise.resolve(dispatch({
            type: actions.ADD_SERVICE_DATA,
            data: service,
            stage: STAGE_SUMMARY
        })).then(() => {
            return dispatch({
                type: actions.SUBMIT_SERVICE,
                data: {
                    id: serviceId,
                    type: service.type,
                    data: omit(service, 'items')
                }
            })
        }).then(() => {
            if (has(service, 'items') && isArray(service.items)) {
                service.items.forEach(itemId => {
                    dispatch(submitServiceItem(serviceId, session.booking.entities.items[itemId], STAGE_SUMMARY));
                });
            }
        }).then(()=> {
            return dispatch(addServiceFromSession({
                ...service,
                items:service.items.map(itemId => session.booking.entities.items[itemId])
            }))
        })
    })
}

const unload = () => ({
    type: actions.UNLOAD,
})

export {
    fetchUserSession,
    getSessionContent,
    fetchRouteList,
    fetchLineList,
    submitEndUser,
    editEndUser,
    showAddService,
    closeAddService,
    addService,
    addServiceData,
    cancelAddService,
    submitService,
    removeService,
    addServiceItem,
    submitServiceItem,
    removeServiceItem,
    toggleEditServiceItem,
    updateServiceItem,
    changeComment,
    cancel,
    showSubmit,
    submit,
    termsReaded,
    termsAccepted,
    termsRejected,
    loadSession,
    saveStateToSession,
    resetSession,
    saveDraft,
    fetchDraft,
    fetchOptimalle,
    fetchHikeList,
    fetchThemes,
    setStage,
    fetchDraftCount,
    unload,
    submitClientData,
    fetchExistingBooking,
    addSessionToDraft
};
